const selectCommunityContentFilter = function ({ commit }, filter) {
  commit("SELECT_COMMUNITY_CONTENT_FILTER", filter);
};

export default selectCommunityContentFilter;
